<template>
  <div>
    <div style="background-color: white; padding: 15px;">
      <div>
        <span style="font-size: 13px; color:#97a8be">首页 / 财务管理 / 待发卡充值</span>
      </div>
    </div>

    <div style="padding: 10px 15px">
      <div>
        <table width="100%">
          <tr>
            <th class="th">
              操作
            </th>
            <th class="th">
              充值单号
            </th>
            <th class="th">
              充值金额
            </th>
            <th class="th">
              充值类型
            </th>
            <th class="th">用户ID</th>
            <th class="th">用户昵称</th>
            <th class="th">手机号码</th>
            <th class="th">收款卡信息</th>
            <th class="th">充值凭证</th>
            <th class="th">充值状态</th>
            <th class="th">备注</th>
            <th class="th">到账时间</th>
            <th class="th">充值时间</th>
          </tr>
          <tr :key="index" v-for="(value,index) in adminList">
            <td class="td" style="width: 80px">
              <div style="overflow: hidden">
                <div @click="sendCard(value.topId,value.topType)" :style="{display:(value.topState=='待发卡')?'':'none'}" style="cursor: pointer; float: left; color: #33cc57">
                  发卡
                </div>
                <div @click="auditWithDraw(value.topId,0)" :style="{display:(value.topState=='待审核')?'':'none'}" style="cursor: pointer; float: left; color: #33cc57">
                  通过
                </div>
                <div @click="auditWithDraw(value.topId,1)" :style="{display:(value.topState=='待审核')?'':'none'}" style="cursor: pointer; margin-left: 10px; float: left; color: #ff0000">
                  驳回
                </div>
              </div>
            </td>
            <td :style="{color:value.topUserName.indexOf('业务员')!=-1?'red':'#606266'}" class="td" style="min-width: 50px;">
              {{ value.topNum }}
            </td>
            <td :style="{color:value.topUserName.indexOf('业务员')!=-1?'red':'#606266'}" class="td">
              {{ value.topPrice }}
            </td>
            <td :style="{color:value.topUserName.indexOf('业务员')!=-1?'red':'#606266'}" class="td">
              {{ value.topType }}
            </td>
            <td :style="{color:value.topUserName.indexOf('业务员')!=-1?'red':'#606266'}" class="td">{{ value.topUserId }}</td>
            <td :style="{color:value.topUserName.indexOf('业务员')!=-1?'red':'#606266'}" class="td">{{ value.topUserName }}</td>
            <td :style="{color:value.topUserName.indexOf('业务员')!=-1?'red':'#606266'}" class="td">{{ value.topUserPhone }}</td>
            <td :style="{color:value.topUserName.indexOf('业务员')!=-1?'red':'#606266'}" class="td">{{ value.topBankNote }}</td>
            <td class="td">
              <template v-if="value.topPhoto!=''">
                <a :href="imgUrl+value.topPhoto" target="_blank" style="color: #1890ff">查看</a>
              </template>
            </td>
            <td :style="{color:value.topUserName.indexOf('业务员')!=-1?'red':'#606266'}" class="td">{{ value.topState }}</td>
            <td :style="{color:value.topUserName.indexOf('业务员')!=-1?'red':'#606266'}" class="td">{{ value.topNote }}</td>
            <td :style="{color:value.topUserName.indexOf('业务员')!=-1?'red':'#606266'}" class="td">{{ value.topToTime }}</td>
            <td :style="{color:value.topUserName.indexOf('业务员')!=-1?'red':'#606266'}" class="td">{{ value.topTime }}</td>
          </tr>
        </table>
      </div>

    </div>
    <div :style="{display:showPrompt==1?'':'none'}" style="position: fixed; _position: absolute; top: 0; left: 0; bottom: 0; right: 0; margin: auto; width: 350px; height: 200px;
background-color: white; box-shadow: 0 0 3px #e8e8e8; z-index: 999">
      <div style="text-align: center; color: black; font-weight: bold; padding: 15px;">
        驳回提现
      </div>
      <div style="padding: 15px; text-align: center">
        <div>
          <input class="boxText" v-model="userInput" placeholder="请输入审核备注" style="width: 90%" />
        </div>
        <div style="padding-top: 25px;">
          <input @click="auditWithDrawByNo" type="button" style="cursor: pointer; padding: 10px 25px; border-radius: 3px; background-color: #1890ff; border: 1px solid #1890ff; color: white" value="确认驳回" />
          <input @click="chanelAudit" type="button" style="cursor: pointer; padding: 10px 25px; border-radius: 3px; background-color: #ffffff; border: 1px solid #dbdbdb; margin-left: 15px; color: #606266" value="返回" />
        </div>
      </div>
    </div>
    <div :style="{display:showBankBox==1?'':'none'}" style="position: fixed; _position: absolute; top: 0; left: 0; bottom: 0; right: 0; margin: auto; width: 550px; height: 390px;
background-color: white; box-shadow: 0 0 5px #aca9a9; z-index: 999">
      <div style="text-align: center; color: black; font-weight: bold; padding: 15px;">
        发送银行卡
      </div>
      <span @click="closeBankBox" style="cursor: pointer; position: absolute; top: 15px; right: 15px; z-index: 999">关闭</span>
      <div style="padding: 15px; text-align: left">
        <div style="height: 310px; overflow-y: scroll">
          <div>
            <table width="100%">
              <tr>
                <th class="th">
                  操作
                </th>
                <th class="th">
                  银行名称
                </th>
                <th class="th">
                  支行
                </th>
                <th class="th">
                  开户人
                </th>
                <th class="th">卡号</th>
              </tr>
              <tr :key="index" v-for="(value,index) in bankList">
                <td class="td">
                  <div style="overflow: hidden">
                    <div @click="sendBank(value.bankId,0)" style="cursor: pointer;color: #33cc57; float: left">
                      发送
                    </div>
                    <div @click="sendBank(value.bankId,1)" style="cursor: pointer; float: left; color: #ff0000; margin-left: 10px;">
                      拒绝
                    </div>
                  </div>
                </td>
                <td class="td" style="min-width: 50px;">
                  {{ value.bankName }}
                </td>
                <td class="td">
                  {{ value.bankChildName }}
                </td>
                <td class="td">
                  {{ value.bankUserName }}
                </td>
                <td class="td">{{ value.bankCard }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {closeLoading, convertDateToISO, DO_NET_URL, loading, toask} from "@/config/config";
import {axiosGet, axiosPost} from "@/main";

export default {
  name: "TopUpList",
  data(){
    return{
      showBankBox:0,
      showPrompt:0,
      userInput: '',
      userId:"",
      phone:"",
      leader:"",
      state:"",
      startTime:"",
      endTime:"",
      adminList:[],
      page:1,
      num:10,
      count:0,
      countPage:0,
      imgUrl:"",
      curId:0,
      bankList:[],
      bankList1:[],
      dsq:null,
      topUser:"",
    }
  },
  mounted(){
    if(localStorage.getItem("topAccount")!=null&&localStorage.getItem("topAccount")!=""){
      this.topUser=localStorage.getItem("topAccount")
    }
    let that=this
    if(localStorage.getItem("iwa_token")==null||localStorage.getItem("iwa_token")==""){
      setTimeout(function (){
        that.$router.replace('index')
      },600);
    }
    this.selectAdminList()
    this.dsq=setInterval(function (){
      that.selectAdminList()
    },5000)

    axiosGet(DO_NET_URL+"api/GetBankByTopUp",function (res){
      that.bankList=res.data
      that.bankList1=res.data
    })
  },
  beforeDestroy() {
    // 销毁前的处理逻辑
    console.log('页面即将销毁');
    clearInterval(this.dsq)
    this.dsq=null
  },
  methods: {
    sendBank(id,type){
      let that=this
      if(type==0){
        if(confirm("确认发送此银行卡？")){
          axiosPost(DO_NET_URL+"topUp/SendBank?topUpId="+this.curId+"&bankId="+id+"&type=0","",function (res){
            if(res.code==200){
              toask("发送成功！",6)
              that.showBankBox=0;
              that.selectAdminList()
            }else{
              toask(res.data,6)
            }
          })
        }
      }else{
        if(confirm("确认驳回此充值？")){
          axiosPost(DO_NET_URL+"topUp/SendBank?topUpId="+this.curId+"&bankId="+id+"&type=1","",function (res){
            if(res.code==200){
              toask("发送成功！",6)
              that.showBankBox=0;
              that.selectAdminList()
            }else{
              toask(res.data,6)
            }
          })
        }
      }

    },
    sendCard(id,type){
      this.curId=id
      this.showBankBox=1
      if(type=="支付宝扫码支付"||type=="支付宝转账"){
        let list=[]
        for(let i=0;i<this.bankList1.length;i++){
          if(this.bankList1[i].bankName=="支付宝"){
            list.push(this.bankList1[i])
          }
        }
        this.bankList=list
      }else{
        let list=[]
        for(let i=0;i<this.bankList1.length;i++){
          if(this.bankList1[i].bankName!="支付宝"){
            list.push(this.bankList1[i])
          }
        }
        this.bankList=list
      }
    },
    closeBankBox(){
      this.showBankBox=0;
    },
    chanelAudit(){
      this.showPrompt=0
    },
    copyBankMsg(id,state,address,price){
      let that=this
      let msg="链：TRC20\n钱包地址：" + address + "\n到账金额："+price
      //执行复制
      const input = document.createElement('textarea');
      input.value = msg; // 设置要复制的文本
      document.body.appendChild(input); // 添加input元素到DOM
      input.select(); // 选中文本
      document.execCommand('copy'); // 执行复制操作
      document.body.removeChild(input); // 移除input元素
      toask('已复制到剪切板',6); // 可选：弹窗提示复制成功
      if(state=="待审核"){
        axiosPost(DO_NET_URL+"withDraw/CopyBankMsgByWithDrawUsdt?id="+id,"",function (res){
          that.selectAdminList()
        })
      }
    },
    updateAdmin(obj){
      localStorage.setItem("UPDATEOBJ",obj)
      this.$emit("send",'issueListByInvestId')
    },
    auditWithDrawByNo(){
      if(this.userInput==""){
        toask("请输入驳回原因！",6)
        return
      }
      if(confirm("确认审核此申请吗？")){
        let that=this
        loading("加载中")
        axiosPost(DO_NET_URL+"withDraw/AuditWithDrawUsdt?id="+this.curId+"&type=1&note="+this.userInput,"",function (res){
          console.log(res.data)
          closeLoading()
          if(res.code==200){
            that.showPrompt=0
            toask("审核成功！",6)
            that.selectAdminList()
          }else{
            toask(res.data,6)
          }
        })
      }
    },
    auditWithDraw(id,type){
      if(confirm("确认审核此申请吗？")){
        let that=this
        loading("加载中")
        axiosPost(DO_NET_URL+"topUp/AuditTopUpUsdt?id="+id+"&type="+type,"",function (res){
          console.log(res.data)
          closeLoading()
          if(res.code==200){
            toask("审核成功！",6)
            that.selectAdminList()
          }else{
            toask(res.data,6)
          }
        })
      }

    },
    deleteAdmin(id){
      if(confirm("确认删除此申请吗？")){
        let that=this
        loading("加载中")
        axiosPost(DO_NET_URL+"filePhoto/DeleteFilePhoto?id="+id,"",function (res){
          console.log(res.data)
          closeLoading()
          if(res.code==200){
            that.selectAdminList()
          }else{
            toask(res.data,6)
          }
        })
      }
    },
    addAdmin(){
      this.$emit("send",'addNews')
    },
    currPage(num){
      if(num==1){
        this.page=1
      }else if(num==5){
        this.page=this.countPage
      }else if(num==2){
        if(this.page>1){
          this.page-=1
        }
      }else{
        if(this.page<this.countPage){
          this.page+=1
        }
      }
      this.selectAdminList()
    },
    async selectAdminList(){
      let that=this
      if(localStorage.getItem("topAccount")!=null&&localStorage.getItem("topAccount")!=""){
        this.topUser=localStorage.getItem("topAccount")
      }
      //loading("加载中")
      axiosGet(DO_NET_URL+"topUp/GetTopUpWaitSendCard?topUser="+this.topUser,function (res){
        console.log(res.data)
        //closeLoading()
        that.adminList=res.data
        // localStorage.setItem("imgUrl",res.data.imgUrl)
      })
    },
  }
}
</script>

<style scoped>
@import 'vue2-datepicker/index.css';
.prompt-box {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
  background-color: #fff;
  padding: 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
}
.prompt-box input {
  width: 100%;
  padding: 10px;
  margin-bottom: 10px;
}
.prompt-box button {
  padding: 10px 15px;
  margin-right: 10px;
  border: none;
  outline: none;
  background-color: #007bff;
  color: white;
  cursor: pointer;
}
.prompt-box button:hover {
  background-color: #0056b3;
}
.text1{
  border: 1px solid #dcdfe6;
  font-size: 12px;
  border-radius: 2px;
  outline: none;
  padding: 3px 10px;
}
.boxText{-webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: 12px;
  height: 35px;
  /*line-height: 40px;*/
  outline: none;
  padding: 0 15px;
  -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  width: 50%;}
.leftTd{
  vertical-align: middle;
  font-size: 12px;
  color: #606266;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;font-weight: 700;}
.addBtn{color: #1890ff;background: #e8f4ff; border: 1px solid #1890ff; cursor: pointer; float: left; font-size: 12px;padding: 7px 15px;border-radius: 3px;}
.th{border-bottom:1px solid #dfe6ec; text-align: left; padding:0 10px;word-break: break-word;background-color: #f8f8f9;color: #515a6e;height: 40px;font-size: 12px;}
.td{border-bottom:1px solid #dfe6ec;padding:0px 10px; width: auto; word-break:break-word;background-color: #ffffff;color: #606266;height: 40px;font-size: 12px;}
</style>